import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    background: 'white',
    borderRadius: 4,
    boxShadow: '0 1px 12px rgba(0,0,0,0.12)',
    zIndex: 2,
    width: 264
  },
  menuItem: {
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    padding: 16,
    alignItems: 'center',
    borderTop: '1px solid whitesmoke',
    color: 'black',
    fontSize: 14,
    ':hover': {
      background: 'whitesmoke'
    }
  },
  menuItemKiffgo: {
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    padding: 16,
    alignItems: 'center',
    borderTop: '1px solid whitesmoke',
    color: 'grey',
    fontSize: 14,
    ':hover': {
      cursor: 'default'
    }
  },
  menuItemKiffgoHoverable: {
    ':hover': {
      background: 'whitesmoke',
      cursor: 'pointer'
    }
  },
  backToAdminIcon: {
    opacity: 0,
    transition: '200ms',
    transform: 'rotate(90deg)'
  },
  backToAdminIconVisible: {
    opacity: 1,
    transform: 'rotate(0deg)'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/sidebar/user-menu-styles.js